// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/electronic-flight-bag.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/electronic-flight-bag/electronic-flight-bag.js';

mount([g0]);
